module.exports = __webpack_public_path__ + "img/Dossieroverzicht.c9058188.png";